import axios from 'axios';
import { API_V1_URL } from '../config';
import { applyInterceptors } from './apiInterceptors';

const api = axios.create({
  baseURL: API_V1_URL,
  withCredentials: true,
  headers: {
    'ngrok-skip-browser-warning': '1',
  },
});

applyInterceptors(api);

export default api;
